var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.content_list, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var m0 = item.type == 2 ? _vm.getJSON(item.content) : null
    var m1 = item.type == 2 ? _vm.getJSON(item.content) : null
    var m2 = item.type == 2 ? _vm.getJSON(item.content) : null
    var m3 = item.type == 3 ? _vm.getJSON(item.content) : null
    var m4 = item.type == 3 ? _vm.getJSON(item.content) : null
    var m5 = item.type == 3 ? _vm.getJSON(item.content) : null
    var m6 = item.type == 3 ? _vm.getJSON(item.content) : null
    var m7 = item.type == 3 ? _vm.getJSON(item.content) : null
    var m8 = item.type == 3 ? _vm.getJSON(item.content) : null
    var m9 = item.type == 3 ? _vm.getJSON(item.content) : null
    var g0 =
      item.type == 5 && _vm.is_order ? _vm.order_chat.product.length : null
    return {
      $orig: $orig,
      m0: m0,
      m1: m1,
      m2: m2,
      m3: m3,
      m4: m4,
      m5: m5,
      m6: m6,
      m7: m7,
      m8: m8,
      m9: m9,
      g0: g0,
    }
  })
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.is_product = false
    }
    _vm.e1 = function ($event) {
      _vm.is_order = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }